export default __webpack_public_path__ + "static/media/ic-thrash-black.1e2d0e53.svg";